import { useSettings } from '@wu/widget-core';
import { MOBILE_WIDTH, TABLET_WIDTH } from '../../constants';

export const usePaddingResult = (width) => {
  const {
    logoPadding,
    logoBackgroundColor,
    logoPaddingTablet,
    logoPaddingMobile
  } = useSettings();

  if (!logoBackgroundColor || logoBackgroundColor === 'transparent') {
    return 0;
  }

  if (width <= MOBILE_WIDTH) {
    return logoPaddingMobile;
  }

  if (width <= TABLET_WIDTH) {
    return logoPaddingTablet;
  }

  return logoPadding;
};
